module.exports = __webpack_public_path__ + "img/detail_banner_qlcjy.3248623e.png";